import { render, staticRenderFns } from "./WinnerModal.vue?vue&type=template&id=c1170746&scoped=true&"
import script from "./WinnerModal.vue?vue&type=script&lang=ts&"
export * from "./WinnerModal.vue?vue&type=script&lang=ts&"
import style0 from "./WinnerModal.vue?vue&type=style&index=0&id=c1170746&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1170746",
  null
  
)

export default component.exports